import React from 'react';

import cx from 'classnames';
import { identity } from 'ramda';
import { useSelector } from 'react-redux';

import RenderInDomNode from 'components/Pages/Admin/Page/common/RenderInStuff';
import s from 'components/shared/ActionButtons/index.module.css';
import Button from 'components/shared/Button';
import { pageDataSelector } from 'store/page/selectors';

import { usePageContext } from '../context';
import { usePageButtons } from './functions';
import styles from './index.module.css';

function PageButtonsWrapper(props) {
  const page = useSelector(pageDataSelector);
  const { lastStep } = usePageContext();

  if (page.id === 0 || page.lastAvailableStep !== lastStep) {
    return null;
  }

  return <PageButtons {...props} />;
}

function PageButtons({
  hasValidationErrors = false,
  submitting = false,
  values = undefined,
  savePageProps,
  publishPageProps,
  onSave,
  isPublishDisabled = false,
  prepareValues = identity,
}) {
  const { doesPageHaveChanges, isCanPending, handlePublish, saveHandler, isShownPublishBtn, isDisabledButton } =
    usePageButtons({ values, savePageProps, publishPageProps, onSave, prepareValues, submitting });
  return (
    <RenderInDomNode id="stuff">
      <div className={styles.group}>
        <Button
          size="medium"
          shape="ellipse"
          className={cx(styles.groupButton, s.button)}
          disabled={hasValidationErrors || isDisabledButton}
          onClick={saveHandler}
          type={!doesPageHaveChanges && 'grey'}
        >
          Save
        </Button>

        {isShownPublishBtn && (
          <Button
            type="default"
            size="medium"
            shape="ellipse"
            className={cx(styles.groupButton, s.button)}
            disabled={isPublishDisabled || hasValidationErrors || isDisabledButton || !isCanPending}
            onClick={() => handlePublish(values, { withConfirmation: true })}
          >
            Publish
          </Button>
        )}
      </div>
    </RenderInDomNode>
  );
}

export default PageButtonsWrapper;
